import { Controller } from 'stimulus';

const csrfParamSelector = "head meta[name='csrf-param']";
const csrfTokenSelector = "head meta[name='csrf-token']";

const ADD_STEP = 'addstep';
const REMOVE_LAST_STEP = 'removelaststep';

export default class extends Controller {
  static targets = [
    'description',
    'for',
    'form',
    'modal',
    'steps',
    'template',
    'token',
    'type',
  ];

  get modal() {
    return this.application.getControllerForElementAndIdentifier(
      this.modalTarget,
      'modal'
    );
  }

  connect() {
    this._csrfParam = document.querySelector(csrfParamSelector).content;
    this._csrfToken = document.querySelector(csrfTokenSelector).content;
  }

  new() {
    this._resetForm();
    this._openModal();
  }

  async submit(event) {
    event.preventDefault();

    const form = event.target;
    const body = JSON.stringify({
      step: {
        step_for: this.forTarget.value,
        step_type: this.typeTarget.value,
        step_description: this.descriptionTarget.value,
      },
      [this._csrfParam]: this._csrfToken,
    });

    await fetch(form.action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    })
      .then(response => response.json())
      .then(json => this._addStep(json));
  }

  async delete(event) {
    event.preventDefault();

    const stepRow = event.target.closest('li[data-step-id]');
    const stepId = stepRow.dataset.stepId;
    const body = JSON.stringify({ [this._csrfParam]: this._csrfToken });

    await fetch(`${this.formTarget.action}/${stepId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body,
    }).then(_ => {
      stepRow.remove();

      if (this.stepsTarget.childElementCount === 0) {
        const stepEvent = new Event(REMOVE_LAST_STEP);
        this.formTarget.dispatchEvent(stepEvent);
      }
    });
  }

  _addStep(step) {
    const content = this.templateTarget.innerHTML
      .replace('STEP_ID', step.id)
      .replace('STEP_DESCRIPTION', step.step_description)
      .replace('STEP_FOR', this._stepForLabel(step.step_for));

    const stepEvent = new Event(ADD_STEP);
    this.formTarget.dispatchEvent(stepEvent);
    this.stepsTarget.insertAdjacentHTML('beforeend', content);
    this.modal.close();
  }

  _resetForm() {
    this.descriptionTarget.value = '';
    this.forTarget.value = '';
  }

  _stepForLabel(stepFor) {
    return /with_you/.exec(stepFor) ? 'For With You' : 'For you';
  }

  _openModal() {
    this.modal.open();
  }
}
